import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import UploadIcon from "@mui/icons-material/Upload";
import {
  Badge,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Icon,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiSelect from "components/SuiSelect";
import SuiTypography from "components/SuiTypography";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import Prompt from "components/UpStyled/Prompt";
import VersionDialog from "components/UpStyled/VersionDialog";
import { AccountContext } from "context/account";
import CounterContext from "context/counter";
import { StoreContext } from "context/store";
import { nanoid } from "nanoid";
import qs from "query-string";
import { useContext, useEffect, useRef, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import toast from "react-hot-toast";
import { TbVersions } from "react-icons/tb";
import api from "services/api";
import DevelopBoard, {
  ExportPdf,
  collaborationActions,
  countBoardCollaborationUpdates,
} from "./DevelopBoard";

import moment from "moment";

const NEW_CHAT_MESSAGE_EVENT = "newChatMessage"; // Name of the event
var deepEqual = require("deep-equal");
const labelProps = {
  elevation: 0,
  sx: {
    overflow: "visible",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
    mt: 1.5,
    "& .MuiAvatar-root": {
      width: 32,
      height: 32,
      ml: -0.5,
      mr: 1,
    },
    "&:before": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: "background.paper",
      transform: "translateY(-50%) rotate(45deg)",
      zIndex: 0,
    },
  },
};

const standardFields = [
  { field: "id", headerName: "id", hide: true, disableReorder: true },
  { field: "Code", headerName: "Code", width: 100, disableReorder: true },
];

const addField = (name, width = 150) => {
  return { field: nanoid(), headerName: name, width: width, editable: true };
};

const currentVersion = 1;
const defaultBoards = [
  {
    id: "Sketches",
    version: currentVersion,
    title: "Sketches",
    sketchdatas: [],
    fields: [],
  },
  {
    id: "BillMaterials",
    version: currentVersion,
    title: "Bill of Materials",
    sketchdatas: [],
    fields: [
      { field: "id", headerName: "id", hide: true, disableReorder: true },
      { field: "Code", headerName: "Parts", width: 100, disableReorder: true },
      {
        field: "ImageData",
        headerName: "Material Image",
        width: 150,
        editable: false,
        disableReorder: true,
      },
      {
        field: "Category",
        headerName: "Category",
        width: 100,
        editable: false,
        disableReorder: true,
      },
      { field: "Name", headerName: "Name", width: 100, editable: false, disableReorder: true },
      { field: "CodeF", headerName: "Code", width: 100, editable: true, disableReorder: true },
      addField("Description", 150),
      { field: "Quantity", headerName: "Quantity", width: 100, editable: true },
      addField("UOM"),
      { field: "Price", headerName: "Price/unit($)", width: 100, editable: true },
      { field: "TotalCost", headerName: "Cost", width: 100, editable: false },
      addField("Placement"),
      addField("Supplier"),
      addField("Color"),
      addField("URL", 100),
    ],
  },
  {
    id: "ConstructionDetails",
    version: currentVersion,
    title: "Construction Details",
    sketchdatas: [],
    fields: [...standardFields, addField("Description", 150)],
  },
  {
    id: "Specs",
    version: currentVersion,
    title: "Specs",
    sketchdatas: [],
    fields: [
      ...standardFields,
      addField("Point of Measure", 150),
      addField("tol +/-"),
      addField("XXS"),
      addField("XS"),
      addField("S"),
      addField("M"),
      addField("L"),
      addField("XL"),
      addField("Comments", 150),
    ],
  },
];

const collaborationModes = [
  { value: "readonly", label: "Manufacturer Read" },
  { value: "collaboration", label: "Collaboration Mode" },
];

const initialStyle = {
  title: "Untitled",
  status: "design",
  description: "",
  options: [],
  collection_id: null,
  style: {
    style_number: "TEMP_" + moment().format("YYYYMMHHmmss"),
    year: moment().format("YYYY"),
  },
};

const DevelopStage = ({ techpackboard, shareSessionRef }) => {
  const account = useContext(AccountContext);
  const { store } = useContext(StoreContext);
  var user_id = account.id;
  var user_name = store.name;
  const [detail, setDetail] = useState(initialStyle);

  const [boards, setBoards] = useState([]);
  const [currentBoard, setCurrentBoard] = useState(undefined);
  const [addingBoard, setAddingBoard] = useState(false);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  const [deleteBoard, setDeleteBoard] = useState(null);
  const [exportPdfDialogVisible, setExportPdfDialogVisible] = useState(false);
  const [versionDialogVisible, setVersionDialogVisible] = useState(false);
  const [collaborationMode, setCollaborationMode] = useState(collaborationModes[1]);
  const [reloadInfo, setReloadInfo] = useState({ show: false });
  const [leaveCollaborationInfo, setLeaveCollaborationInfo] = useState({ show: false });
  const [reloadIndex, setReloadIndex] = useState(nanoid());
  const [editmode, setEditmode] = useState(nanoid());
  const [detailImage, setDetailImage] = useState({});

  const url = location.href ? location.href : location.pathname + location.search;

  const urlParams = new URLSearchParams(window.location.search);
  let styleId = urlParams.get("id");
  let projectId = urlParams.get("pid");
  let techpackboardId = urlParams.get("techpackboard");

  const boardsRef = useRef(null);
  boardsRef.current = boards;
  const isDirtyRef = useRef(false);
  const editmodeRef = useRef(0);
  const techpackboardRef = useRef();
  techpackboardRef.current = techpackboardId ?? techpackboard;
  const currentBoardRef = useRef();
  currentBoardRef.current = currentBoard;
  const counter = useContext(CounterContext);
  const { sendCountSignal } = counter;

  var ongoingProject = detail?.provider_id !== undefined && detail?.provider_id !== "";

  const countCollaborationUpdates = () => {
    var myCount = 0;
    var otherCount = 0;
    for (var board of boards) {
      const boardcounts = countBoardCollaborationUpdates(detail, board);
      myCount += boardcounts.myCount;
      otherCount += boardcounts.otherCount;
    }
    //console.log('myCount', myCount, 'otherCount', otherCount)
    return { myCount, otherCount };
  };

  const loadData = async () => {
    if (!styleId) {
      let item = detail;
      item.perms = 2;
      item.style.techpacks = { boards: [], versions: [] };
      setBoards(defaultBoards);
      setCurrentBoard(null);
      setReloadIndex(nanoid());
      let collaborationMode2 = collaborationModes[1];
      setCollaborationMode(collaborationModes[1]);

      editmodeRef.current = ongoingProject && collaborationMode2.value === "collaboration" ? 3 : 1;

      if (item.mode && item.mode === 2) editmodeRef.current = 0;
      item.user_id = user_id;
      item.user_name = user_name;
      item.account_type = account.account_type;
      item.editmode = editmodeRef.current;
      setEditmode(editmodeRef.current);

      setDetail(item);
    } else {
      api.products.retrieve(styleId).then(({ data }) => {
        let item = data.product;

        //console.log('data', data, boards)
        if (data.product?.style) item.style = data.product?.style;
        if (data.product?.perms || data.product?.perms === 0) item.perms = data.product?.perms;
        else item.perms = 2;
        if (Array.isArray(item.style.boards)) {
          item.style.techpacks = {
            boards: item.style.boards,
            versions: item.style.versions ?? [],
          };
          delete item.style.boards;
          if (item.style.versions) delete item.style.versions;
        } else if (!item.style.techpacks) item.style.techpacks = { boards: [], versions: [] };
        var newboards = (item.style.techpacks.boards ?? []).filter(
          (b) => b.version >= currentVersion
        );
        if (newboards.length === 0) newboards = JSON.parse(JSON.stringify(defaultBoards));
        setBoards(newboards);
        var newCurrentBoard = newboards.find((b) => b.id === techpackboardRef.current);
        //console.log('currentBoard', currentBoardRef.current, 'newCurrentBoard', newCurrentBoard, deepEqual(currentBoardRef.current, newCurrentBoard))
        if (
          boards.length === 0 ||
          currentBoardRef.current === undefined ||
          !deepEqual(currentBoardRef.current, newCurrentBoard)
        ) {
          //console.log('currentBoard2')
          setCurrentBoard(
            newCurrentBoard ??
              (currentBoardRef.current !== null && newboards.length > 0 ? newboards[0] : null)
          );
          setReloadIndex(nanoid());
        }
        var collaborationMode2 = item.style.techpacks.collaboration
          ? collaborationModes.find((c) => c.value === item.style.techpacks.collaboration)
          : collaborationModes[1];
        setCollaborationMode(collaborationMode2);
        /*editmode  
      shared user readonly 0 
      owner 1 write / approve
      shared user proposal 2  proposal
      ownercollaboration 3   proposal / approve
      manufacturer proposal 4   proposal / approve
      */
        if (user_id === item.store_id) {
          editmodeRef.current =
            ongoingProject && collaborationMode2.value === "collaboration" ? 3 : 1;
        } else {
          if (ongoingProject) {
            editmodeRef.current = collaborationMode2.value === "readonly" ? 0 : 4;
          } else {
            if (item.style.techpacks.collaboration === "collaboration") editmodeRef.current = 0;
            else editmodeRef.current = item.perms > 1 ? 2 : 0;
          }
        }
        if (item.mode && item.mode === 2) editmodeRef.current = 0;
        item.user_id = user_id;
        item.user_name = user_name;
        item.account_type = account.account_type;
        item.editmode = editmodeRef.current;
        setEditmode(editmodeRef.current);

        setDetail(item);

        //console.log('editmodeRef.current', editmodeRef.current, 'ongoingProject', ongoingProject, 'collaborationMode2', collaborationMode2, 'detail.perms', detail.perms, 'detail.user_id', detail.user_id, 'detail.user_name', detail.user_name)
        return data;
      });
    }
  };
  useEffect(() => {
    loadData();
  }, [styleId]);

  useEffect(() => {
    shareSessionRef.current.refeshfunc = loadData;
    shareSessionRef.current.savefunc = () => {
      saveTechPacks(isDirtyRef.current);
    };

    if (styleId) {
      const timer = setInterval(() => {
        if (isDirtyRef.current) {
          if (!detail.style?.techpacks) {
            detail.style.techpacks = {};
          }
          detail.style.techpacks.boards = boardsRef.current;
          saveTechPacks();
        }
      }, 1000);

      return () => {
        clearInterval(timer);
        shareSessionRef.current.refeshfunc = null;
        shareSessionRef.current.savefunc = null;
      };
    }
  }, [styleId, detail]);

  useEffect(() => {
    if (styleId && currentBoard !== undefined) {
      var url = new window.URL(document.location); // fx. http://host.com/endpoint?abc=123
      url.searchParams.set("id", styleId);
      if (detail.project_id) {
        url.searchParams.set("pid", detail.project_id);
      }
      if (currentBoard !== null) {
        url.searchParams.set("techpackboard", currentBoard.id);
      }

      techpackboardRef.current = currentBoard?.id ?? null;
      window.history.replaceState("", "style", url.toString());

      //console.log('currentBoard', currentBoard, newqs)
    }
  }, [currentBoard]);

  const updateBoard = (boardId, sketchDatas, tableFields, collaborationHistory) => {
    const nextDatas = boards.map((b) => {
      if (b.id === boardId) {
        return {
          ...b,
          sketchdatas: sketchDatas,
          fields: tableFields,
          collaborationhistory: collaborationHistory,
        };
      } else {
        return b;
      }
    });
    setBoards(nextDatas);
    isDirtyRef.current = true;
  };

  const sendNotification = (targetUserId) => {
    var url = location.pathname + location.search;
    let pos = url.indexOf("&techpackboard=");
    if (pos > 0) url = url.substring(0, pos);
    pos = url.indexOf("&imgid=");
    if (pos > 0) url = url.substring(0, pos);
    //console.log('message', message)
    //console.log('detail', detail)
    //console.log('board', board)
    //console.log('location', location)
    // detail.project_name + (true ? "" : "(" + detail.title + " / " + board?.title + ")") +
    var desc = "Style " + detail.title + " updated.";
    var payload = {
      type: "Tech Pack",
      target: url + "&techpackboard=" + currentBoard?.id,
      descr: desc,
    };
    payload.user_id = targetUserId;
    //console.log('payload', payload)
    try {
      api.notifications.create(payload).then(({ data }) => {
        sendCountSignal(payload.user_id);
        return data;
      });
    } catch (err) {
      console.log(err);
    }
  };

  const saveTechPacks = async (isdirty = true, defaultStyle = detail) => {
    try {
      if (isdirty) {
        isDirtyRef.current = false;

        if (styleId) {
          await api.products.update(
            styleId,
            { style: defaultStyle.style },
            defaultStyle.project_id
          );
        } else {
          let payload = {
            title: defaultStyle?.title || "Untitled",
            status: "design",
            description: "",
            options: [],
            collection_id: null,
          };
          const newCreatedProduct = await api.products.create(payload);
          let product_id = newCreatedProduct?.data?.product?.id;
          if (product_id) {
            await api.products.update(
              product_id,
              { style: defaultStyle.style },
              defaultStyle.project_id
            );

            var url = new window.URL(document.location);
            url.searchParams.set("id", product_id);
            window.history.replaceState("", "style", url.toString());
          }
        }
        //toast.success("Save online tech packs successfully!");
        //console.log('socketRef.current', socketRef.current, user_name, user_id)
        if (editmodeRef.current)
          shareSessionRef.current.socket?.emit(NEW_CHAT_MESSAGE_EVENT, {
            senderId: shareSessionRef.current.user_id,
            sessionId: shareSessionRef.current.id,
            contacts: [],
            dt: new Date(),
          });
        if (editmodeRef.current === 2 || editmodeRef.current === 4)
          sendNotification(defaultStyle.store_id);
        else if (editmodeRef.current === 3) sendNotification(defaultStyle.provider_id);
      }
    } catch (e) {
      console.log(e);
      toast.error("Save online tech packs failed!");
    }
  };

  const handleDrop = (droppedItem) => {
    if (!droppedItem.destination) return;
    var updatedList = [...boards];
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
    setBoards(updatedList);
    isDirtyRef.current = true;
  };

  const LeaveCollaborationDialog = ({}) => {
    const collaborationActions2 = (checkrole, isAccept) => {
      const nextDatas = boards.map((board) => {
        var result = collaborationActions(board, board.sketchdatas, checkrole, isAccept);
        return { ...board, sketchdatas: result.newDatas, fields: result.newFields };
      });
      setBoards(nextDatas);
      setReloadIndex(nanoid());
      setCurrentBoard(
        nextDatas.find((b) => b.id === techpackboardRef.current) ??
          (techpackboardRef.current && nextDatas.length > 0 ? nextDatas[0] : null)
      );
      isDirtyRef.current = true;
    };

    return (
      <Dialog
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "720px",
              height: "500px",
            },
          },
        }}
        open={leaveCollaborationInfo.show}
        maxWidth={"lg"}
        onClose={() => setLeaveCollaborationInfo({ show: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Leave Collaboration Mode
          <IconButton
            aria-label="close"
            onClick={() => setLeaveCollaborationInfo({ show: false })}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <SuiTypography>
            Before leave collaboration mode, please withdrawal, accept or decline pending proposals.
          </SuiTypography>
          {leaveCollaborationInfo.myCount > 0 && (
            <SuiBox
              sx={{ width: "100%", my: 1 }}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <SuiTypography>{leaveCollaborationInfo.myCount} Designer's Proposals</SuiTypography>
              <SuiButton
                onClick={() => {
                  setLeaveCollaborationInfo({ ...leaveCollaborationInfo, myCount: 0 });
                  collaborationActions2((r) => r === detail.user_id, false);
                }}
                color={"secondary"}
                variant="gradient"
              >
                Withdrawal
              </SuiButton>
            </SuiBox>
          )}
          {leaveCollaborationInfo.otherCount > 0 && (
            <SuiBox
              sx={{ width: "100%", my: 1 }}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <SuiTypography>
                {leaveCollaborationInfo.otherCount} Manufacturer's Proposals
              </SuiTypography>
              <SuiBox display="flex" alignItems="center">
                <SuiButton
                  sx={{ ml: 1 }}
                  onClick={() => {
                    setLeaveCollaborationInfo({ ...leaveCollaborationInfo, otherCount: 0 });
                    collaborationActions2((r) => r !== detail.user_id, true);
                  }}
                  color={"secondary"}
                  variant="gradient"
                >
                  Accept
                </SuiButton>
                <SuiButton
                  sx={{ ml: 1 }}
                  onClick={() => {
                    setLeaveCollaborationInfo({ ...leaveCollaborationInfo, otherCount: 0 });
                    collaborationActions2((r) => r !== detail.user_id, false);
                  }}
                  color={"secondary"}
                  variant="gradient"
                >
                  Decline
                </SuiButton>
              </SuiBox>
            </SuiBox>
          )}
        </DialogContent>
        <DialogActions>
          <SuiButton
            disabled={leaveCollaborationInfo.myCount > 0 || leaveCollaborationInfo.otherCount > 0}
            onClick={() => {
              setLeaveCollaborationInfo({ show: false });
              setReloadIndex(nanoid());
              setCollaborationMode(leaveCollaborationInfo.option);
              detail.style.techpacks.collaboration = leaveCollaborationInfo.option.value;
              saveTechPacks();
            }}
            color={"secondary"}
            variant="gradient"
          >
            Switch Mode
          </SuiButton>
        </DialogActions>
      </Dialog>
    );
  };

  const RenderBoardMenu = ({ board }) => {
    const [openMenu, setOpenMenu] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
      setOpenMenu(true);
      event.stopPropagation();
      event.preventDefault();
    };
    const handleClose = (event) => {
      setAnchorEl(null);
      setOpenMenu(false);
      event.stopPropagation();
      event.preventDefault();
    };

    return (
      <>
        <Tooltip title="Options" placement="top-start">
          <IconButton
            onClick={handleClick}
            size="small"
            aria-controls={openMenu ? "board-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={openMenu ? "true" : undefined}
          >
            <MoreVertIcon
              fontSize="small"
              color="inherit"
              className="border-none hover:bg-transparent"
            />
          </IconButton>
        </Tooltip>
        <Menu
          anchorEl={anchorEl}
          id="board-menu"
          open={openMenu}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={labelProps}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              const newDatas = boards.map((b) => {
                if (b.id == board.id) return { ...b, editing: true };
                else return b;
              });
              setBoards(newDatas);
            }}
          >
            <EditIcon className="align-middle" fontSize="small" />
            <SuiTypography>&nbsp;&nbsp;Edit Title</SuiTypography>
          </MenuItem>
          <MenuItem
            onClick={(e) => {
              setDeleteBoard(board);
              setDeleteDialogVisible(true);
              e.stopPropagation();
            }}
          >
            <DeleteIcon className="align-middle" fontSize="small" />
            <SuiTypography>&nbsp;&nbsp;Delete</SuiTypography>
          </MenuItem>
        </Menu>
      </>
    );
  };

  const addNewBoard = (event) => {
    if (event.target.value.length > 0) {
      var newboard = {
        id: nanoid(),
        version: currentVersion,
        title: event.target.value,
        sketchdatas: [],
        fields: [...standardFields, addField("Description", 150), addField("Comments", 150)],
      };
      setBoards([...boards, newboard]);
      isDirtyRef.current = true;
      setCurrentBoard(newboard);
    }
    setAddingBoard(false);
  };

  return (
    <Card className="h-fit">
      <ExportPdf
        detail={detail}
        exportPdfDialogVisible={exportPdfDialogVisible}
        setExportPdfDialogVisible={setExportPdfDialogVisible}
        styleTitle={
          detail?.title +
          (detail?.style?.style_number !== "" ? "(" + detail?.style?.style_number + ")" : "")
        }
        boards={boards}
      />
      <Prompt
        heading={"Refresh"}
        text={`${reloadInfo.senderName} updated ${detail.title}. Do you want to refresh this page?`}
        visible={reloadInfo.show}
        okText={"Refresh"}
        okColor="dark"
        handleOk={() => {
          setReloadInfo({ show: false });
          //location.reload()
          loadData();
        }}
        handleClose={() => setReloadInfo({ show: false })}
      />
      <Prompt
        heading={deleteBoard ? "Delete Confirmation" : "Reset Confirmation"}
        text={
          deleteBoard
            ? `Are you sure you want to delete "${deleteBoard?.title}"?`
            : "Are you sure you want to reset all boards back to default?"
        }
        visible={deleteDialogVisible}
        okText={deleteBoard ? "Delete" : "Reset"}
        okColor="dark"
        handleOk={() => {
          console.log("detail.user_id", detail.user_id);
          setDeleteDialogVisible(false);
          setDeleteBoard(null);
          var newboards = null;
          if (editmode > 1 && deleteBoard) {
            newboards = boards.map((b) => {
              if (b.id !== deleteBoard.id) return b;
              var cnt = 0;
              for (var s of b.sketchdatas) cnt += s.lines.length;
              if (cnt === 0) return null;
              var newsketchdatas = b.sketchdatas.map((s) => {
                var newlines = s.lines.map((l) => {
                  return {
                    ...l,
                    PEProle: detail.user_id,
                    PEPname: detail.user_name,
                    PEPdate: new Date(),
                    v: l.index,
                    PEPvalue: "",
                  };
                });
                return { ...s, lines: newlines };
              });
              return { ...b, sketchdatas: newsketchdatas };
            });
            newboards = newboards.filter((b) => {
              return b !== null;
            });
            //console.log('newboards', newboards)
          } else {
            newboards = deleteBoard
              ? boards.filter((b) => {
                  return b.id !== deleteBoard.id;
                })
              : JSON.parse(JSON.stringify(defaultBoards));
          }
          setCurrentBoard(
            newboards.find((b) => b.id === currentBoard?.id) ??
              (newboards.length > 0 ? newboards[0] : null)
          );
          setBoards(newboards);
          setReloadIndex(nanoid());
          isDirtyRef.current = true;
        }}
        handleClose={() => setDeleteDialogVisible(false)}
      />
      <Prompt
        visible={detailImage.show}
        handleClose={() => setDetailImage({})}
        handleOk={() => setDetailImage({})}
        option={{ maxWidth: "xl" }}
        text={
          <SuiBox pt={1}>
            <ImageCardWrapper
              data={detailImage.img}
              mode={"normal"}
              sx={{ maxHeight: 640, minHeight: 300 }}
              isOriginalSize
              pdfPagination={true}
            />
          </SuiBox>
        }
        hideAction
      />
      <VersionDialog
        versionDialogVisible={versionDialogVisible}
        setVersionDialogVisible={setVersionDialogVisible}
        versionsArg={detail.style.techpacks?.versions}
        dataArg={boards}
        saveFunc={(newVersions, selectVersionData = null) => {
          detail.style.techpacks.versions = newVersions;
          if (selectVersionData) {
            detail.style.techpacks.boards = selectVersionData;
            setBoards(detail.style.techpacks.boards);
            setCurrentBoard(
              detail.style.techpacks.boards.find((b) => b.id === currentBoard?.id) ??
                (detail.style.techpacks.boards.length > 0 ? detail.style.techpacks.boards[0] : null)
            );
            setReloadIndex(nanoid());
          }
          saveTechPacks();
        }}
      />
      <LeaveCollaborationDialog />
      <div className="min-w-full grid grid-cols-7 gap-2">
        <Card className="col-span-1 overflow-hidden">
          <div className="pl-1 py-1">
            <ul className="overflow-auto h-auto mb-1">
              {user_id === detail.store_id && ongoingProject && false && (
                <SuiBox sx={{ width: "100%", p: "3px" }}>
                  <SuiSelect
                    size="medium"
                    options={collaborationModes}
                    onChange={(option) => {
                      if (collaborationMode.value !== option.value) {
                        if (collaborationMode.value === "collaboration") {
                          const counts = countCollaborationUpdates();
                          if (counts.myCount > 0 || counts.otherCount > 0) {
                            setLeaveCollaborationInfo({ ...counts, show: true, option: option });
                            return;
                          }
                        }
                        setCollaborationMode(option);
                        detail.style.techpacks.collaboration = option.value;
                        saveTechPacks();
                      }
                    }}
                    value={collaborationMode}
                  />
                </SuiBox>
              )}
              {user_id === detail.provider_id && ongoingProject && false && (
                <SuiBox sx={{ width: "100%", p: "3px" }}>
                  <SuiTypography variant="body1">Mode: {collaborationMode.label}</SuiTypography>
                </SuiBox>
              )}
              {editmode > 0 && (
                <SuiBox className={`flex items-center p-1 border-l-4 border-gray-100`}>
                  <Tooltip title="Add a new online tech pack" placement="top-start">
                    <IconButton
                      size="medium"
                      sx={{ mx: -0.5 }}
                      onClick={(e) => {
                        setAddingBoard(true);
                        e.stopPropagation();
                      }}
                    >
                      <Icon
                        fontSize="medium"
                        color="inherit"
                        className="border-none hover:bg-transparent"
                      >
                        add
                      </Icon>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Export online tech packs to PDF file" placement="top-start">
                    <IconButton
                      size="medium"
                      sx={{ mx: -0.5 }}
                      onClick={(e) => {
                        setExportPdfDialogVisible(true);
                      }}
                    >
                      <PictureAsPdfIcon
                        fontSize="medium"
                        color="inherit"
                        className="border-none hover:bg-transparent"
                      />
                    </IconButton>
                  </Tooltip>
                  {false && editmode === 1 && (
                    <Tooltip title="Reset tech packs to default" placement="top-start">
                      <IconButton
                        size="medium"
                        sx={{ mx: -0.5 }}
                        onClick={(e) => {
                          setDeleteBoard(null);
                          setDeleteDialogVisible(true);
                          e.stopPropagation();
                        }}
                      >
                        <RestartAltIcon
                          fontSize="medium"
                          color="inherit"
                          className="border-none hover:bg-transparent"
                        />
                      </IconButton>
                    </Tooltip>
                  )}
                  {(editmode === 1 || editmode === 3) && (
                    <Tooltip title="Version Control" placement="top-start">
                      <IconButton
                        size="medium"
                        sx={{ mx: -0.5 }}
                        onClick={(e) => {
                          setVersionDialogVisible(true);
                        }}
                      >
                        <TbVersions
                          fontSize="large"
                          color="inherit"
                          className="border-none hover:bg-transparent"
                        />
                      </IconButton>
                    </Tooltip>
                  )}
                </SuiBox>
              )}
              <DragDropContext onDragEnd={handleDrop}>
                <Droppable droppableId="column-container" direction="vertical">
                  {(provided) => (
                    <div
                      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      {boards.map((board, index) => (
                        <Draggable
                          id={board.id}
                          key={board.id}
                          draggableId={board.id}
                          index={index}
                          isDragDisabled={!editmode}
                        >
                          {(provided) => {
                            provided.draggableProps.style = {
                              ...provided.draggableProps.style,
                              width: "100%",
                            };
                            const waitingCounts = countBoardCollaborationUpdates(
                              detail,
                              board
                            ).otherCount;
                            return (
                              <div
                                ref={provided.innerRef}
                                {...provided.dragHandleProps}
                                {...provided.draggableProps}
                              >
                                <SuiBox
                                  key={board.id}
                                  className={`flex items-center w-full px-1 py-[2px] border-l-4 border-gray-100 ${
                                    board.id == currentBoard?.id ? "active bg-gray-100" : ""
                                  }`}
                                  onClick={() => {
                                    setCurrentBoard(board);
                                  }}
                                >
                                  <div className="w-full pb-0 h-[40px] flex items-center">
                                    {board.editing && (
                                      <SuiBox sx={{ px: 1 }}>
                                        <SuiInput
                                          autoFocus
                                          size="small"
                                          defaultValue={board.title ?? board.id}
                                          onKeyUp={(event) => {
                                            // console.log('event', event)
                                            if (event.key === "Enter") {
                                              const newDatas = boards.map((b) => {
                                                if (b.id == board.id)
                                                  return {
                                                    ...b,
                                                    editing: false,
                                                    title: event.target.value,
                                                  };
                                                else return b;
                                              });
                                              setBoards(newDatas);
                                              isDirtyRef.current = true;
                                            }
                                            if (event.key === "Escape") {
                                              const newDatas = boards.map((b) => {
                                                if (b.id == board.id)
                                                  return { ...b, editing: false };
                                                else return b;
                                              });
                                              setBoards(newDatas);
                                            }
                                            event.stopPropagation();
                                          }}
                                          onBlur={(event) => {
                                            // console.log('onBlur')
                                            const newDatas = boards.map((b) => {
                                              if (b.id == board.id)
                                                return {
                                                  ...b,
                                                  editing: false,
                                                  title: event.target.value,
                                                };
                                              else return b;
                                            });
                                            setBoards(newDatas);
                                            isDirtyRef.current = true;
                                          }}
                                        />
                                      </SuiBox>
                                    )}
                                    {!board.editing && (
                                      <SuiBox
                                        width="100%"
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="space-between"
                                      >
                                        <SuiBox sx={{ flexGrow: 1 }}>
                                          <Badge
                                            color="error"
                                            badgeContent={waitingCounts}
                                            size="small"
                                            invisible={waitingCounts <= 0}
                                            max={9}
                                          >
                                            <SuiTypography
                                              variant="body1"
                                              className={`ml-0 text-gray-600`}
                                              lineHeight="1"
                                            >
                                              {board.title ?? board.id}&nbsp;&nbsp;
                                            </SuiTypography>
                                          </Badge>
                                        </SuiBox>
                                        {editmode > 0 && <RenderBoardMenu board={board} />}
                                      </SuiBox>
                                    )}
                                  </div>
                                </SuiBox>
                              </div>
                            );
                          }}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
              {editmode > 0 && addingBoard && (
                <SuiBox className={`flex items-center p-1 border-l-4 border-gray-100`}>
                  <SuiBox sx={{ px: 1 }}>
                    <SuiInput
                      autoFocus
                      onKeyUp={(event) => {
                        if (event.key === "Enter") {
                          addNewBoard(event);
                        }
                        if (event.key === "Escape") {
                          setAddingBoard(false);
                        }
                      }}
                      onBlur={(event) => {
                        addNewBoard(event);
                      }}
                    />
                  </SuiBox>
                </SuiBox>
              )}
            </ul>
            <Divider
              style={{ background: "black" }}
              sx={{ py: "1px", m: 0 }}
              light={false}
              flexItem
            />
            <SuiBox
              sx={{ cursor: "pointer", mt: 1 }}
              className={`min-h-[45px] flex items-center ${
                currentBoard == null ? "active bg-gray-100" : ""
              }`}
              onClick={() => {
                setCurrentBoard(null);
              }}
            >
              <SuiBox display="flex" alignItems="center">
                {editmode > 0 && <UploadIcon />}
                <SuiTypography variant="body1">
                  {editmode ? "Upload Existing Tech Packs" : "Existing Tech Packs"}
                </SuiTypography>
              </SuiBox>
            </SuiBox>
            <Divider
              style={{ background: "black" }}
              sx={{ py: "1px", m: 0 }}
              light={false}
              flexItem
            />
            <SuiBox sx={{ overflowX: "hidden", overflowY: "auto", maxHeight: "600px" }}>
              <SuiTypography variant="body1" sx={{ py: 1, px: 0.5 }}>
                Style Images:
              </SuiTypography>
              {detail.style?.imageFiles?.map((imgfile) => {
                return (
                  <SuiBox
                    sx={{ pb: 1, width: "auto", border: "0px solid lightgray" }}
                    onClick={() => setDetailImage({ show: true, img: imgfile })}
                  >
                    <img src={imgfile.url} style={{ width: "100%" }} />
                  </SuiBox>
                );
              })}
            </SuiBox>
          </div>
        </Card>
        <Card className="col-span-6 h-fit">
          <div className="w-full">
            <DevelopBoard
              detail={detail}
              key={currentBoard?.id + reloadIndex}
              board={currentBoard}
              updateBoard={updateBoard}
              editmode={editmode}
            />
          </div>
        </Card>
      </div>
    </Card>
  );
};

export default DevelopStage;
